enum UserRole {
  USER = "user",
  OWNER = "owner",
  ADMIN = "admin",
  CREATOR = "creator",
  OBSERVER = "observer",
  REVIEWER = "reviewer",
  LEARNER = "learner",
  SPEAKER = "speaker",
  ASSESSMENT_CREATOR = "assessmentcreator",
  ASSESSMENT_ADMIN = "assessmentadmin",
  USER_GROUP_CREATOR = "usergroupcreator",
  ROLE_ADMIN = "roleadmin",
  CAFE_CREATOR = "cafecreator",
  LEADERSHIP = "leadership",
  AI_COURSE_CREATOR = "aiCourseCreator",
  RECRUITER = "recruiter",
  REPORT_ADMIN = "reportAdmin",
  INTERVIEW_ADMIN = "interview-admin",
  AI_AUTHORING_CREATOR = "ai-authoring-user",
  CERTIFICATE_AUTHOR = "certificateAdmin"
}

export type UserRoleKey = keyof typeof UserRole;

const USER_ROLE_VALUES = Object.values(UserRole) as string[];

export function normalizeRbacActiveRoles(
  activeRoles: string[] | undefined | null
): UserRole[] {
  if (!activeRoles?.length) return [];
  return activeRoles.map((raw) => {
    const s = String(raw).trim();
    const match = USER_ROLE_VALUES.find(
      (ev) => ev.toLowerCase() === s.toLowerCase()
    );
    return (match ?? s.toLowerCase()) as UserRole;
  });
}

export function shouldHideContentLibraryTabsForRecruiter(
  role: UserRole[] | undefined | null
): boolean {
  if (!role?.length) return false;
  if (!role.includes(UserRole.RECRUITER)) return false;
  if (role.includes(UserRole.CREATOR) || role.includes(UserRole.REVIEWER)) {
    return false;
  }
  return true;
}

export default UserRole;
